import React from 'react'
import './Partners.css'


import glatt from '../../../../assets/images/partnership/partner3.png'


const Partners = () => {
  return (
    <section className="partners">

      <div className="partners-container">

        {/* TITLE */}
        <h2>Our Partners</h2>

        {/* LOGOS */}
        <div className="partners-logos">


          <img src={glatt} className="bglogop" alt="glatt" />


        </div>

        {/* TEXT */}
        <p className="partners-text">
          These collaborations support technology transfer, regulatory compliance,
          and sustainable operational excellence.
        </p>

      </div>

    </section>
  )
}

export default Partners